import type { ReactNode } from 'react';

import { useEffect, useRef } from 'react';

import { useAPIDesignerStore, type APIv2ReferencePayload } from '.';

interface InitializeAPIDesignerStoreProps {
  apiObject?: APIv2ReferencePayload;
  children: ReactNode;
}

export function InitializeAPIDesignerStore({ children, apiObject }: InitializeAPIDesignerStoreProps) {
  const [isReady, initialize] = useAPIDesignerStore(s => [s.isReady, s.initialize]);
  const initializedApiObjectRef = useRef<APIv2ReferencePayload>();

  if (apiObject && (!isReady || initializedApiObjectRef.current !== apiObject)) {
    initializedApiObjectRef.current = apiObject;
    initialize({ apiObject });
  }

  useEffect(() => {
    if (apiObject && initializedApiObjectRef.current !== apiObject) {
      initializedApiObjectRef.current = apiObject;
      initialize({ apiObject });
    }
  }, [initialize, apiObject]);

  return <>{children}</>;
}
